/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */

document.addEventListener('DOMContentLoaded', () => {
    'use strict'
  
    var groupClass = 'wp-block-atb-accordions-tabs-group'; // accordion-group
    var accordionClass = '.wp-block-atb-accordion-tab'; // accordion-container

    var accordionsGroup = document.getElementsByClassName( groupClass );
  
    var createAccordion = function(event) {
        console.log("clicked");

        const   target = event.target,
                targetContainer = target.closest( accordionClass ),
                targetHeader = target.closest('.accordion-heading'),
                targetGroup = target.closest('.'+groupClass),
                targetContainers = [...targetGroup.querySelectorAll( accordionClass )],
                headingLi = [...targetGroup.querySelectorAll('.accordion-mobile-heading')],
                targetControls = target.getAttribute('aria-controls'),
                targetContent = document.getElementById(targetControls),
                targetMobileHeading = target.closest('.accordion-mobile-heading');
        var exclusiveGroup = "false";
        exclusiveGroup = targetGroup.dataset.exclusive;
    
        if (targetContainer && targetHeader || targetMobileHeading) {
            target.classList.toggle('active');
            
            if (targetContent.style.maxHeight) {
                // accordion is currently open, so close it
                targetContent.style.maxHeight = null;
                target.setAttribute('aria-expanded', 'false');
            } else {
                // accordion is currently closed, open it by expanding by the height of the content
                targetContent.style.maxHeight = targetContent.scrollHeight + "px";
                /* targetContent.closest( accordionClass ).style.minHeight = targetGroup.getAttribute("maxcontentheight"); */
                target.setAttribute('aria-expanded', 'true');
            }

            if (targetContainer && targetHeader){
                // if click on accordion version
                targetContainers.forEach((elem) => {
                   
                    if (elem != targetContainer && exclusiveGroup !== "true" ) {
                        // all other accordion are closed 
                        elem.querySelector('.accordion__control').classList.remove('active');
                        elem.querySelector('.accordion__control').setAttribute('aria-expanded', 'false');
                        elem.querySelector('.accordion-content').style.maxHeight = null;
                        /* elem.style.minHeight = null; */
                      
                    } 
                });
            }
            if (targetMobileHeading){
                // if click on tabs version
                var elementCibleId = targetControls,
                    elementCible = document.getElementById( elementCibleId );

                targetMobileHeading.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});

                targetContainers.forEach((elem) => {
                   if (elem != elementCible.parentNode ) {
                       // all other texts are closed 
                       elem.querySelector('.accordion-content').style.maxHeight = null;
                       /* elem.style.minHeight = null; */
                     
                     
                   } 
                });
                headingLi.forEach((elem)=>{
                    if (elem != targetMobileHeading){
                        elem.querySelector('.accordion__control').classList.remove('active');
                        elem.querySelector('.accordion__control').setAttribute('aria-expanded', 'false');
                    }
                });
            }
            

        };
    };
  
  
    // for every accordion group
    for (var i = 0; i < accordionsGroup.length; i++) {

      // get a list of containers inside group and for each container measure the tallest element in the content
      /*var accordContainers = accordionsGroup[i].getElementsByClassName('accordion-container');
      var heights = [];
      for (var x = 0; x < accordContainers.length; x++) {
        heights.push(accordContainers[x].firstElementChild.scrollHeight);      
      }
      accordionsGroup[i].setAttribute("maxcontentheight", Math.max(...heights) + "px");*/
        
      // add Event Listener and actions on accordion groups
      accordionsGroup[i].addEventListener('click', createAccordion, false);
      
    }
});

/*
Inspirations, help and examples
- Brad Frost's Accordions to Full (https://codepen.io/bradfrost/pen/dlwBD)
- Aaron Pinero's Responsive Tabs (https://codepen.io/aaronpinero/pen/lqAGm)
- Shaan simple native accordions (https://webdevtrick.com/html-css-javascript-accordion-source-code/)
- Anton Floretsky's autoclosing accordions (https://codepen.io/floretsky/pen/qBEQmEV?editors=1000)
- Dan Smith Aria tabs (https://codepen.io/dapacreative/pen/PqXxoP)
- Bootstrap's Collapse element (https://getbootstrap.com/docs/4.4/components/collapse/)
*/


/* eslint-enable no-console */
